var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-user-review" },
    [
      _c("product-review-head", {
        staticClass: "product-user-review__head",
        attrs: {
          name: _vm.name,
          date: _vm.date,
          city: _vm.city,
          rating: _vm.rating,
          "use-time": _vm.useTime,
          recommended: _vm.recommended
        }
      }),
      _c(
        "message-cloud",
        {
          staticClass: "product-user-review__message",
          attrs: {
            size: _vm.size,
            pros: _vm.pros,
            cons: _vm.cons,
            text: _vm.text
          }
        },
        _vm._l(_vm.comments, function(comment, index) {
          return _c("product-review-answer", {
            key: index,
            attrs: {
              text: comment.text,
              date: _vm.createdDate(comment.created_at)
            }
          })
        }),
        1
      ),
      _c("review-likes", {
        staticClass: "product-user-review__likes",
        attrs: { likes: _vm.localLikes, dislikes: _vm.localDislikes },
        on: { like: _vm.onLike, dislike: _vm.onDislike }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }